import { loader } from 'graphql.macro'

export default async function updateRecurringTickets ({ dataLoaders, variables }) {
  const schema = loader('./updateRecurringTickets.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateRecurringTickets
}
